export function isIterable(input) {
    if (typeof input !== 'object' || input === null)
        return false;
    return input[Symbol.iterator] !== undefined;
}
export function isAsyncIterable(input) {
    if (typeof input !== 'object' || input === null)
        return false;
    return input[Symbol.asyncIterator] !== undefined;
}
